import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import Spinner from "../../common/spinners/Spinner";
import { SelectField } from "@unite-us/ui";
import "../../InsuranceInformation/stylesheets/PaymentsInsuranceFields.scss";
import { theme } from "../../../../tailwind.config";
import "../stylesheets/SocialInsuranceFields.scss";
import { useFindPrimaryPlans, useFindPrimaryInsurances } from "../hooks";
import moment from 'moment';
var PrimaryHealthInsurance = function PrimaryHealthInsurance(_ref) {
  var value = _ref.value,
    label = _ref.label;
  return /*#__PURE__*/React.createElement("div", {
    className: "space-y-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "uppercase text-dark-blue text-xs font-heavy-font tracking-wider social-insurance-fields--required"
  }, label), /*#__PURE__*/React.createElement("div", null, value));
};
var ListPrimaryHealthInsurances = function ListPrimaryHealthInsurances(_ref2) {
  var value = _ref2.value,
    label = _ref2.label;
  return /*#__PURE__*/React.createElement("div", {
    className: "space-y-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "uppercase text-red text-xs font-heavy-font tracking-wider social-insurance-fields--required"
  }, label), /*#__PURE__*/React.createElement("div", null, "To add this social care coverage, the client must have a matching health insurance. Please add a matching health insurance:", /*#__PURE__*/React.createElement("ul", {
    className: "list-disc"
  }, _mapInstanceProperty(value).call(value, function (plan) {
    return /*#__PURE__*/React.createElement("li", {
      key: plan.id,
      className: "list-disc"
    }, plan.name);
  }))));
};
export var PrimaryInsuranceDisplay = function PrimaryInsuranceDisplay(_ref3) {
  var selectedPlan = _ref3.selectedPlan,
    primaryInsuranceIdTuple = _ref3.primaryInsuranceIdTuple,
    contactId = _ref3.contactId;
  var _primaryInsuranceIdTu = _slicedToArray(primaryInsuranceIdTuple, 2),
    primaryInsuranceId = _primaryInsuranceIdTu[0],
    setPrimaryInsuranceId = _primaryInsuranceIdTu[1];
  var _useFindPrimaryPlans = useFindPrimaryPlans(selectedPlan),
    primaryPlans = _useFindPrimaryPlans.primaryPlans,
    isPlansLoading = _useFindPrimaryPlans.isPlansLoading;
  var _useFindPrimaryInsura = useFindPrimaryInsurances(contactId),
    primaryInsurances = _useFindPrimaryInsura.primaryInsurances,
    isInsurancesLoading = _useFindPrimaryInsura.isInsurancesLoading;
  var primaryInsuranceOptions = _filterInstanceProperty(primaryInsurances).call(primaryInsurances, function (insurance) {
    return _findInstanceProperty(primaryPlans).call(primaryPlans, function (plan) {
      return plan.id === insurance.plan.id;
    });
  });
  useEffect(function () {
    if (primaryInsuranceOptions.length === 1) setPrimaryInsuranceId(primaryInsuranceOptions[0].id);
  }, [primaryInsuranceOptions]);
  if (isPlansLoading || isInsurancesLoading) {
    return /*#__PURE__*/React.createElement(Spinner, {
      scale: 0.5
    });
  }
  if (primaryInsuranceOptions.length === 1) {
    return /*#__PURE__*/React.createElement(PrimaryHealthInsurance, {
      value: primaryInsuranceOptions[0].plan.name,
      label: "Primary Insurance"
    });
  }
  if (primaryInsuranceOptions.length === 0) {
    return /*#__PURE__*/React.createElement(ListPrimaryHealthInsurances, {
      value: primaryPlans,
      label: "Primary Insurance"
    });
  }
  var primaryInsuranceDropdownOptions = _mapInstanceProperty(primaryInsuranceOptions).call(primaryInsuranceOptions, function (insurance) {
    var _context, _context2;
    var formatDate = function formatDate(date) {
      return date ? moment(date).utc().format('MM/DD/YYYY') : '--';
    };
    var startDate = formatDate(insurance.enrolled_at);
    var endDate = formatDate(insurance.expired_at);
    return {
      display_name: _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "".concat(insurance.plan.name, " (Start Date: ")).call(_context2, startDate, " End Date: ")).call(_context, endDate, ")"),
      value: insurance.id
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "payments-insurance-fields content-container space-y-2 py-2",
    "data-testid": "required-insurance-plans"
  }, /*#__PURE__*/React.createElement(SelectField, {
    className: "payments-insurance-fields__plan",
    id: "required-insurance-plan",
    label: "Primary Insurance Plan",
    labelKey: "display_name",
    options: primaryInsuranceDropdownOptions,
    placeholder: "Choose primary insurance plan...",
    searchResultLimit: 250,
    required: true,
    value: primaryInsuranceId,
    onChange: setPrimaryInsuranceId,
    style: {
      error: {
        height: 0
      },
      label: {
        color: theme.extend.colors["dark-blue"]
      }
    }
  }));
};
PrimaryInsuranceDisplay.propTypes = {
  selectedPlan: PropTypes.object.isRequired,
  primaryInsuranceIdTuple: PropTypes.array.isRequired,
  contactId: PropTypes.string.isRequired
};
PrimaryInsuranceDisplay.defaultProps = {
  selectedPlan: {},
  primaryInsuranceIdTuple: []
};
export default PrimaryInsuranceDisplay;
//# sourceMappingURL=PrimaryInsuranceDisplay.js.map